"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var page_html_1 = __importDefault(require("./page.html"));
require("./page.less");
require("@components/page/page-header/page-header");
require("@components/page/page-footer/page-footer");
(function (module) {
    'use strict';
    PageController.$inject = [
        '$routeParams',
        'prPageLayoutService',
        'prEventService',
        'prHeaderFooterService',
        'prPartialDataService'
    ];
    /*
     * Responsible for laying out any widgets it has
     */
    function PageController($routeParams, pageLayout, eventService, headerFooter, prPartialDataService) {
        var $ctrl = this;
        angular.extend($ctrl, {
            isPublic: $routeParams.publicHash || $routeParams.preview,
            pageMargins: pageLayout.getMargins(),
            headerFooter: headerFooter,
            pageBreakDeleted: false,
            $onInit: function () {
                eventService.on('updatePageMargins.PageController', function () {
                    $ctrl.pageMargins = pageLayout.getMargins();
                });
            },
            $onDestroy: function () {
                delete $ctrl.page;
                $ctrl = null;
                eventService.off('updatePageMargins.PageController');
            },
            showPartialDataExportBanner: function () {
                return prPartialDataService.usingPartialData();
            }
        });
    }
    module.component('prPage', {
        templateUrl: page_html_1.default,
        bindings: {
            page: '<page',
            pageNumber: '<pageNumber'
        },
        controller: PageController
    });
}(angular.module('qualtrics.pr')));
